import { Flex } from '@mantine/core';
import { GenericErrorPage } from 'src/error/GenericErrorPage';
import type { StepProps } from 'src/UI/drawer-flow/DrawerFlow';
import DrawerFlowScreenLayout from 'src/UI/drawer-flow/DrawerFlowScreenLayout';
import PageLoader from 'src/UI/loader/PageLoader';
import {
  SELECTION_MODE,
  SelectableList,
} from 'src/common/components/selectable-list/SelectableList';
import type { AutoBrandData } from 'src/secret-menu/auto-brand/types';
import { useCompanies, type Company } from 'src/secret-menu/hooks/useCompanies';

export default function SelectTenantStep(props: StepProps<AutoBrandData>) {
  const { data, setData } = props;
  const { companies, isLoading, isError, error } = useCompanies();

  if (isError) {
    return <GenericErrorPage error={error} />;
  }

  if (isLoading || !companies) {
    return <PageLoader />;
  }

  return (
    <DrawerFlowScreenLayout
      {...props}
      title="Select tenant"
      description="Select the tenant you wish to brand"
      canGoForward={data.company !== null}
      showClientName={false}
      hideProgress
    >
      <Flex direction="column" mih={0} h="100%" style={{ flexShrink: 1, flexGrow: 0 }}>
        <SelectableList
          items={companies}
          selectionMode={SELECTION_MODE.SINGLE}
          selectedItems={data.company ? [data.company] : []}
          onSelectItem={(company: Company) => {
            setData({ ...data, company });
          }}
          getItemId={(company: Company) => company.id}
          getItemLabel={(company: Company) => company.name}
          searchTermMatchFunction={(item: Company, searchTerm: string) => {
            const q = searchTerm.toLowerCase();
            return item.name.toLowerCase().includes(q) || item.tenantName.toLowerCase().includes(q);
          }}
        />
      </Flex>
    </DrawerFlowScreenLayout>
  );
}
